import { attendeeFetchData, attendeeDeleteData, attendeeSendData, attendeePutData } from "./index";

const quizAPI = {
  fetch: (attendeeId, sessionId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/quiz`),
  send: (attendeeId, sessionId, data) => attendeePutData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/quiz`, data),
}

export default quizAPI;